const pricingFAQs = [
  {
    question: 'What is considered an Account?',
    answers: [
      `An Account is any asset, liability, or entity added to your portfolio.
      `,
      `
      An account could be a Checking Account, a 401(k), a Business, a Real Estate Property, and a Mortgage, etc.
      `,
      `
        Nested Accounts are considered in your pricing plan. If have an account, such as Business, with a sub account, such as a business checking account, it would be recognized as two accounts.
      `,
    ],
  },
  {
    question: 'What is an Integration?',
    answers: [
      `
      Integrations provide connections to external data sources in order to retrieve values related to your portfolio.
      `,
      `
      You can use these values in account valuations, assessments, and other features.
      `,
      `
        For example, you may want to retrieve an estimate for a real estate property in your portfolio and use that value as the valuation. You would enable the Zillow integration and reference the Zestimate in your valuation for that account.
      `,
    ],
  },
  {
    question: 'What is an Assessment?',
    answers: [
      `
      Assessments are custom, real-time reports created to visualize important pieces of your portfolio. These charts will automatically be updated as values in your portfolio change.

      `,
      `
        For example, you can create an Assessment that generates a line chart plotting your net worth over the last twelve months or a pie chart showing your portfolio distribution based on different investment sectors.
      `,
      // `
      //  ...and you are billed on the number of Assessments created,
      //   not on the resulting generated reports and charts.
      //   The above example would be billed as two Assessments.
      // `,
    ],
  },
];

export default pricingFAQs;



// WEBPACK FOOTER //
// ./src/services/faqs.js